export default __webpack_public_path__ + "static/area-content-img-0c12d352162ecc7f2152ee9891b7de11.png";